import React, { FC } from 'react';
import { DialogContent } from '@material-ui/core';
import {
  Dialog,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import { IExamSubject } from 'src/content/employee/interface/employee-exam-result.interface';
import CloseIcon from '@mui/icons-material/Close';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { withStyles } from '@mui/styles';
import { TableColumnCell } from 'src/components/TableColumnCell';

interface IExamResultViewMoreProps {
  open: boolean;
  onClose: () => void;
  subjects: IExamSubject[];
}

const CustomTableRow = withStyles({
  root: {
    background: '#E6E9FF !important',
    height: '3.5rem'
  }
})(TableRow);

const ExamResultViewMore: React.FC<IExamResultViewMoreProps> = ({
  open,
  onClose,
  subjects
}) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Grid container justifyContent="space-between" marginBottom="1rem">
          <Grid
            item xs={12}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginBottom="1rem"
          >
            <Typography
              variant="body2"
              sx={{ fontSize: '14px', fontWeight: 'bold' }}
            >
              View Subjects
            </Typography>
            <CloseIcon
              sx={{ fontSize: '20px', cursor: 'pointer' }}
              onClick={handleOnClose}
            />
          </Grid>
          <TableContainer sx={{ maxHeight: '22rem'}}>
            <Table sx={{ borderCollapse: 'separate'}} size="small">
              <TableHead>
                <CustomTableRow sx={{ py: 10 }}>
                  <TableHeaderCell content="Subjects" smallFont />
                  <TableHeaderCell content="Topics" smallFont />
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {subjects &&
                  subjects?.length > 0 &&
                  subjects.map((listItem, i) => {
                    return (
                      <TableRow hover key={i}>
                        <TableColumnCell borderLeft={true}>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem.subjectName || '-'}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell borderRight={true} borderLeft={true}>
                          {listItem.topics &&
                            listItem.topics?.length > 0 &&
                            listItem.topics.map((topic, i) => (
                              <Typography
                                key={i}
                                paddingBottom="0.25rem"
                                paddingTop="0.5rem"
                                style={{ fontSize: '11px' }}
                                variant="body2"
                                gutterBottom
                                noWrap
                              >
                                {topic.topicName || '-'}
                              </Typography>
                            ))}
                        </TableColumnCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ExamResultViewMore;
